import { Trans } from "react-i18next";
import {
  PrivacyPolicyText,
  SectionContainer,
  SectionTitle,
} from "../PrivacyPolicyContent.styled";

export const SecurityPersonalDataSectionContent = (
  props: SecurityPersonalDataSectionContentProps
) => {
  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.securityPersonalData.title"} />
      </SectionTitle>
      <PrivacyPolicyText>
        <Trans i18nKey={"privacyPolicy.securityPersonalData.text"} />
      </PrivacyPolicyText>
    </SectionContainer>
  );
};

export interface SecurityPersonalDataSectionContentProps {}
